import { Order } from '../../brands/models/Order';
import { filterPlacesIds } from '../../helpers/filterPlacesIds/filterPlacesIds';
import { getQueryString } from '../../helpers/getQueryString';
const createCriteria = (placeIds) => ({
    locations: {
        mapping: placeIds.map((id) => ({ id })),
    },
});
export const createLastSearch = ({ publicUri, searchModel, title, technicalUrl }, defaultOrder) => {
    const qs = getQueryString({ searchModel, order: Order.Recency, page: 1 }, defaultOrder);
    const searchUrl = new URL(`/${technicalUrl}?${qs}`, publicUri);
    const link = searchUrl.toString();
    const { locations = [] } = searchModel;
    const placeIds = filterPlacesIds(locations);
    const criteria = placeIds.length ? createCriteria(placeIds) : undefined;
    return {
        link,
        title,
        timestamp: new Date().toISOString(),
        ...(criteria ? { criteria } : {}),
    };
};
